<template>
  <el-dialog
    v-if="visibles"
    v-el-drag-dialog
    :visible.sync="visibles"
    :close-on-click-modal="false"
    :close-on-press-escape="false"
    :lock-scroll="false"
    :before-close="closeDialog"
    :show-close="false"
    center
    top="4vh"
    width="55%"
  >
    <dialog-header
      slot="title"
      :title="
        !isEdit
          ? $t('system.department.create')
          : $t('system.department.update')
      "
      :icon="!isEdit ? 'icon-dialog-add' : 'icon-dialog-update'"
      @close="closeDialog"
    />
    <el-row type="flex" justify="center">
      <el-col :span="24">
        <el-form
          ref="formCenter"
          status-icon
          :rules="rules"
          :model="formInfo"
          label-suffix="："
          :label-width="$t('system.company.dialogLabelWidth')"
        >
          <vue-linetitle
            :title="this.$t('system.department.info')"
            :icon-config="{ icon: 'approve-car-info' }"
          >
            <el-row style="padding-top: 10px">
              <el-col :span="11">
                <el-form-item
                  :label="$t('system.department.name')"
                  prop="departmentName"
                  required
                  :show-message="false"
                >
                  <el-input
                    v-model="formInfo.departmentName"
                    maxlength="50"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </vue-linetitle>
          <vue-linetitle
            :title="this.$t('system.company.admin')"
            :icon-config="{ icon: 'approve-car' }"
          >
            <el-row style="padding-top: 10px">
              <!--管理员信息-->
              <el-col :span="11">
                <el-form-item
                  :label="$t('system.company.adminAccount')"
                  prop="loginName"
                  required
                  :show-message="false"
                >
                  <el-input
                    v-model="formInfo.loginName"
                    maxlength="50"
                    clearable
                    :disabled="this.isEdit"
                  />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-tag
                  style="margin-left: 15px"
                  effect="dark"
                  size="medium"
                  type="warning"
                  >{{ this.$t("public.defaultpassword") }}</el-tag
                >
              </el-col>
            </el-row>

            <el-row>
              <el-col :span="11">
                <el-form-item
                  :label="$t('system.company.adminRealName')"
                  prop="realName"
                  required
                  :show-message="false"
                >
                  <el-input
                    v-model="formInfo.realName"
                    maxlength="255"
                    clearable
                  />
                </el-form-item>
              </el-col>
              <el-col :span="11">
                <el-form-item
                  :label="$t('system.company.phoneNumber')"
                  prop="mobile"
                >
                  <el-input
                    v-model="formInfo.mobile"
                    maxlength="10"
                    type="tel"
                    clearable
                  />
                </el-form-item>
              </el-col>
            </el-row>
          </vue-linetitle>
          <vue-linetitle
            :title="this.$t('system.company.remark')"
            :icon-config="{ icon: 'car2-no' }"
          >
            <el-form-item
              :label="$t('public.note')"
              style="padding-top: 10px"
            >
              <el-input
                v-model="formInfo.remark"
                :rows="3"
                :autosize="{ minRows: 3, maxRows: 3 }"
                resize="none"
                :placeholder="$t('public.note')"
                type="textarea"
                maxlength="500"
                show-word-limit
              />
            </el-form-item>
          </vue-linetitle>
        </el-form>
      </el-col>
    </el-row>
    <span slot="footer" class="dialog-footer">
      <el-button class="dialog-cancel" type="primary" @click="headleCancel">{{
        $t("public.cancel")
      }}</el-button>
      <el-button type="primary" @click="submitForm">{{
        $t("public.define")
      }}</el-button>
    </span>
  </el-dialog>
</template>

<script>
import { partialForm } from '@/mixins/partialForm'
// request
import { createUrl, updateUrl } from '@/api/system/department'
import { getMobile } from '@/api/system/user'
export default {
  mixins: [partialForm],
  props: {
    visibles: {
      type: Boolean,
      default: false
    },
    isEdit: {
      type: Boolean,
      default: false
    },
    data: {
      type: Object,
      default: () => ([])
    }
  },
  data() {
    const reg = /^\d{10}$/
    const validatemobile = (rule, value, callback) => {
      if (value && !reg.test(value)) {
        return callback(new Error(this.$t('system.company.valid.mobile')))
      } else {
        callback()
      }
    }
    return {
      formInfo: {
      },
      rules: {
        mobile: [{ trigger: 'change', validator: validatemobile }]
      }
    }
  },
  watch: {
    visibles: {
      // eslint-disable-next-line no-unused-vars
      handler(e1) {
        this.formInfo = { ...this.data }
        this.formInfo.mobile = ''
        if (this.formInfo.userId) {
          getMobile(this.formInfo.userId).then(res => {
            if (res.data.code == 0) {
              this.formInfo.mobile = res.data.data
            }
          })
        }
      },
      immediate: true
    }
  },
  methods: {
    // 关闭dialog
    closeDialog() {
      this.$emit('update:visibles', false)
      this.formInfo = {}
    },
    // 点击取消
    headleCancel() {
      this.closeDialog()
    },
    // 新增
    _companyAdd(postData) {
      this.$http.post(createUrl, postData).then(({ data }) => {
        if (data.code === 0) {
          this.$message.success({
            message: this.$t('public.createSuccess'),
            duration: 2 * 1000
          })
          this.$emit('add-complete')
          this.closeDialog()
        }
      })
    },
    // 编辑
    _companyUpdate(postData) {
      this.$http.post(updateUrl, postData).then(({ data }) => {
        if (data.code === 0) {
          this.$emit('update-complete')
          this.closeDialog()
        }
      })
    },
    // 点击提交
    submitForm() {
      const formcenter = this.checkForm({
        formName: 'formCenter',
        formList: ['departmentName', 'loginName', 'realName', 'mobile']
      })
      if (!formcenter) {
        return
      }
      const { ...postData } = this.formInfo

      if (!this.isEdit) {
        this._companyAdd(postData)
      } else {
        // postData.btnid = btnid
        this._companyUpdate(postData)
      }
    }
  }
}

</script>
